import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useCompanyContext } from '../../../../context/CompanyContext';
import ErrorMessage from '../../../../components/messages/ErrorMessage';
import { fetchPREmployeeEarnings } from '../../../../services/accounting/PayrollService';
import EarningsTable from './EarningsTable';
import { PayrollFilters } from '../PRFilters';
import { useFormContext } from 'react-hook-form';

const EarningsTableContainer = React.forwardRef<HTMLDivElement>(
  (props, ref) => {
    const { selectedCompany } = useCompanyContext();
    const { watch } = useFormContext<PayrollFilters>();
    const filters = watch();

    const { data, isFetching, isError } = useQuery({
      queryKey: [
        'getPREarnings',
        selectedCompany,
        filters.employeeStatus,
        filters.period,
      ],
      queryFn: ({ signal }) => {
        return fetchPREmployeeEarnings(
          selectedCompany!.id,
          filters.employeeStatus,
          filters.period,
          signal
        );
      },
      refetchOnWindowFocus: false,
      enabled: !!selectedCompany,
    });

    if (isFetching || !selectedCompany)
      return (
        <div className="text-center mx-auto mt-3">
          <ProgressSpinner />
        </div>
      );

    if (isError)
      return (
        <ErrorMessage
          content={'Failed to obtain data! Please try again later.'}
        />
      );

    return <EarningsTable earnings={data} />;
  }
);

export default EarningsTableContainer;
